
import barba from '@barba/core';
import Swiper from 'swiper';

export default class{

	constructor(){

        barba.hooks.afterOnce((data) => {
            this.heroSlider()
            this.servicesSlider()
            this.featuresSlider()
            this.featuresSlider01()
            this.featuresSlider01_pc()
            this.featuresSlider02()
            this.featuresSlider02_pc()
            this.featuresSlider03()
        })
        barba.hooks.after((data) => {
            this.heroSlider()
            this.servicesSlider()
            this.featuresSlider()
            this.featuresSlider01()
            this.featuresSlider01_pc()
            this.featuresSlider02()
            this.featuresSlider02_pc()
            this.featuresSlider03()
        });
        
    }
    
    heroSlider(){
        new Swiper ('#l-hero__slider',{
            loop: true,
            effect :'fade',
            speed: 1000,
            allowTouchMove :false,
            simulateTouch:false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets'
            },
            autoplay: {
                delay: 4000
            }
        })
    }
    featuresSlider() {
        new Swiper ('.js-features-slider',{
            loop: true,
            speed:500,
            pagination: {
                el: '.index-features-slider01 .swiper-pagination', // ページネーション要素のクラス
                clickable: true,
            },
            navigation: {
                nextEl: '.js-features-slider .swiper-button-next', // 「次へ」ボタン要素のクラス
                prevEl: '.js-features-slider .swiper-button-prev', // 「前へ」ボタン要素のクラス
            },
        })
    }
    servicesSlider() {
        new Swiper ('.js-services-slider01',{
            loop: true,
            speed:500,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
              },
            autoplay: {
                delay: 4000
            }
        })
    }
    
    featuresSlider01() {
        new Swiper ('.js-features-slider01',{
            loop: true,
            speed:500,
            pagination: {
                el: '.index-features-slider01 .swiper-pagination', // ページネーション要素のクラス
                clickable: true,
            },
            navigation: {
                nextEl: '.js-features-slider01 .swiper-button-next', // 「次へ」ボタン要素のクラス
                prevEl: '.js-features-slider01 .swiper-button-prev', // 「前へ」ボタン要素のクラス
            },
        })
    }
    featuresSlider01_pc() {
        new Swiper ('.js-features-slider01_pc',{
            loop: true,
            speed:500,
            pagination: {
                el: '.index-features-slider01_pc .swiper-pagination', // ページネーション要素のクラス
                clickable: true,
            },
            navigation: {
                nextEl: '.js-features-slider01_pc .swiper-button-next', // 「次へ」ボタン要素のクラス
                prevEl: '.js-features-slider01_pc .swiper-button-prev', // 「前へ」ボタン要素のクラス
            },
        })
    }
    featuresSlider02() {
        new Swiper ('.js-features-slider02',{
            loop: true,
            speed:500,
            pagination: {
                el: '.index-features-slider02 .swiper-pagination', // ページネーション要素のクラス
                clickable: true,
            },
            navigation: {
                nextEl: '.js-features-slider02 .swiper-button-next', // 「次へ」ボタン要素のクラス
                prevEl: '.js-features-slider02 .swiper-button-prev', // 「前へ」ボタン要素のクラス
            },
        })
    }
    featuresSlider02_pc() {
        new Swiper ('.js-features-slider02_pc',{
            loop: true,
            speed:500,
            pagination: {
                el: '.index-features-slider02_pc .swiper-pagination', // ページネーション要素のクラス
                clickable: true,
            },
            navigation: {
                nextEl: '.js-features-slider02_pc .swiper-button-next', // 「次へ」ボタン要素のクラス
                prevEl: '.js-features-slider02_pc .swiper-button-prev', // 「前へ」ボタン要素のクラス
            },
        })
    }
    featuresSlider03() {
        new Swiper ('.js-features-slider03',{
            loop: true,
            speed:500,
            pagination: {
                el: '.index-features-slider03 .swiper-pagination', // ページネーション要素のクラス
                clickable: true,
            },
            navigation: {
                nextEl: '.js-features-slider03 .swiper-button-next', // 「次へ」ボタン要素のクラス
                prevEl: '.js-features-slider03 .swiper-button-prev', // 「前へ」ボタン要素のクラス
            },
        })
    }
}